import { render, staticRenderFns } from "./BudgetVizTab.vue?vue&type=template&id=16541217&scoped=true"
import script from "./BudgetVizTab.vue?vue&type=script&lang=js"
export * from "./BudgetVizTab.vue?vue&type=script&lang=js"
import style0 from "./BudgetVizTab.vue?vue&type=style&index=0&id=16541217&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16541217",
  null
  
)

export default component.exports